import React from 'react'
import { Button, Container, Row, Col } from 'react-bootstrap';
import styles from './home.module.scss';
import { Link } from 'react-router-dom';

const HomeHero = () => {
    return (<>

        <div className={styles.heroContainer}>
            <Container>
                <h1 className="bolder">Quality Improvement and monitoring at your fingerprints</h1>
                <div className={styles.heroInner}>
                    <h2 className="mb-4 mt-4">Get to know the AHRQ Quality Indicators</h2>
                    <Row className={styles.heroRow}>
                        <Col md={3} className='mb-5' className={styles.cardBorder}>
                            <h2>PQI</h2>
                            <h4>Prevention Quality Indicators</h4>
                            <Link
                                className="white mt-2 bolder large"
                                role="button"
                                to="/measures/pqi_resources"
                                >Learn More <i class="fa fa-chevron-right small"></i></Link>
                                </Col>
                        <Col md={3}  className='mb-5' className={styles.cardBorder}>
                            <h2>IQI</h2>
                            <h4>Inpatient Quality Indicators</h4>
                            <Link
                                className="white mt-2 bolder large"
                               role="button"
                                to="/measures/iqi_resources"
                            >Learn More <i class="fa fa-chevron-right small"></i></Link>
                        </Col>
                        <Col md={3}  className='mb-5' className={styles.cardBorder} >
                            <h2>PSI</h2>
                            <h4>Patient Safety <br />Indicators</h4>
                            <Link
                                className="white mt-2 bolder large"
                                role="button"
                                to="/measures/psi_resources"
                                >Learn More <i class="fa fa-chevron-right small"></i></Link>
                                </Col>
                        <Col md={3}  className='mb-5'>
                            <h2>PDI</h2>
                            <h4>Pediatric Quality Indicators</h4>
                            <Link
                                className="white mt-2 bolder large"
                                role="button"
                                to="/measures/pdi_resources"
                                >Learn More <i class="fa fa-chevron-right small"></i></Link>
                                </Col>
                    </Row>
                </div>
            </Container>
        </div>
    </>)
}

export default HomeHero;